import { observer } from 'mobx-react-lite';
import * as R from 'ramda';
import * as React from 'react';
import { withDefaultProps } from 'react-default-props-context';
import { AuthorT } from 'src/api/types/AuthorT';
import { ReferenceT } from 'src/api/types/ReferenceT';
import { SelfTestT } from 'src/api/types/SelfTestT';
import { PaginatingDiv } from 'src/frames/components/PaginatingDiv';
import { Portal } from 'src/frames/components/Portal';
import { CloseIcon } from 'src/frames/icons/CloseIcon';
import { cn } from 'src/frames/utils/cn';
import { AuthorView } from 'src/summary/components/AuthorView';
import { ReferenceView } from 'src/summary/components/ReferenceView';
import './SourcesView.scss';

type PropsT = {
  className?: any;
  setShowSources: (showSources: boolean) => void;
};

type DefaultPropsT = {
  portalElm: any;
  selfTest: SelfTestT;
};

export const SourcesView = observer(
  withDefaultProps<PropsT, DefaultPropsT>((props: PropsT & DefaultPropsT) => {
    const [pageNr, setPageNr] = React.useState(0);

    const authorDivs = R.map((x: AuthorT) => {
      return <AuthorView key={x.name} author={x} />;
    }, props.selfTest.authorSet);

    const referenceDivs = (R.addIndex(R.map) as any)(
      (x: ReferenceT, idx: number) => {
        return <ReferenceView key={idx} reference={x} />;
      },
      props.selfTest.referenceSet
    );

    return (
      <div className={cn('SourcesView', 'flex flex-col', props.className)}>
        <Portal elm={props.portalElm}>
          <div
            className={cn(
              'SourcesView__TitleInPortal',
              'flex flex-row justify-between',
              'flex-1'
            )}
          >
            <div className="flex-1 text-center">Autoren & Quellen</div>
            <div className={cn('SourcesView__CloseButton', 'ml-2')}>
              <button onClick={() => props.setShowSources(false)}>
                <CloseIcon />
              </button>
            </div>
          </div>
        </Portal>
        <div
          className={cn(
            'SourcesView__Card',
            'flex flex-col',
            'flex-1',
            'px-4 py-2'
          )}
        >
          <PaginatingDiv
            id="SourcesView__Card"
            className={cn('SourcesView__Card', 'flex flex-col')}
            pageNr={pageNr}
          >
            {authorDivs}
            {referenceDivs.length > 0 && (
              <div className={cn('SourcesView__TitleQuellen', 'mb-2')}>
                Quellen
              </div>
            )}
            {referenceDivs}
          </PaginatingDiv>
          <div
            className={cn(
              'SourcesView__Paginator',
              'py-4',
              'flex flex-row justify-center'
            )}
          >
            <div
              className={cn('SourcesView__PaginatorButton')}
              onClick={() => {
                const elm = document.getElementById('SourcesView__Card');
                if (elm) {
                  const nrPages = Math.ceil(
                    elm.scrollHeight / elm.clientHeight
                  );
                  setPageNr(Math.min(nrPages - 1, pageNr + 1));
                }
              }}
            >
              {'▽'}
            </div>
            <div
              className={cn('SourcesView__PaginatorButton', 'ml-16')}
              onClick={() => setPageNr(Math.max(0, pageNr - 1))}
            >
              {'△'}
            </div>
          </div>
        </div>
      </div>
    );
  })
);
